module.exports = __webpack_public_path__ + "static/media/price1.15226699.png";